// removed by extract-text-webpack-plugin
module.exports = {"image":"_1CHgW6zNeg_thG6t8bVQsf","frame_wrapper":"_3C_y5bXhLpaHl_vnwkQJrq","frame":"_3bFodSyNdrnMUSKQNhW3Kg","frame_wrapper__angle":"_2hUj1_3VQ7wC1Y-WTxWF70","frame_image_wrapper":"_2DK616ePdW42nywiZHh_Xg","frame_image":"_39UkojK9juUFCtvDY5BvGJ"};


//////////////////
// WEBPACK FOOTER
// ../components/Head/style.module.less
// module id = 416
// module chunks = 0